<template>
  <div>
    <div class="page-title mb-30">Firmware & Software</div>
    <div class="page-content max-w-1000" v-loading="loading">
      <div class="mb-15">Production</div>
      <el-table border size="small" :data="data" class="mb-20">
        <el-table-column label="Software" prop="software"></el-table-column>
        <el-table-column label="Environment">
          <template slot-scope="scope">
            <div v-if="scope.row.isProduction">
              {{ environments.production }}
            </div>
            <div v-if="scope.row.isStaging">{{ environments.staging }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Type" prop="type"></el-table-column>
        <el-table-column
          label="Version"
          prop="fwVersion"
          width="100px"
        ></el-table-column>
        <el-table-column label="Uploaded" prop="uploadedDate">
          <template slot-scope="scope">
            {{ moment(scope.row.uploadedDate).format('DD/MM/YYYY @ hh:mma') }}
          </template>
        </el-table-column>
        <el-table-column label="Uploaded By" prop="userName"></el-table-column>
      </el-table>
      <div class="text-right mb-20">
        <el-button
          v-if="p('Production.Firmware & Software.Upload')"
          class="cancel-btn mini-btn"
          @click="uploadNew()"
          >UPLOAD NEW PRODUCTION FW</el-button
        >
      </div>
      <div class="mb-15">Release History</div>
      <el-table border size="small" :data="releaseHistory">
        <el-table-column
          label="Software"
          prop="software"
          fixed="left"
        ></el-table-column>
        <el-table-column label="Environment">
          <template slot-scope="scope">
            <div v-if="scope.row.isProduction">
              {{ environments.production }}
            </div>
            <div v-if="scope.row.isStaging">{{ environments.staging }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Type" prop="type"></el-table-column>
        <el-table-column
          label="Version"
          prop="fwVersion"
          width="100px"
        ></el-table-column>
        <el-table-column label="Uploaded" prop="uploadedDate">
          <template slot-scope="scope">
            {{ moment(scope.row.uploadedDate).format('DD/MM/YYYY @ hh:mma') }}
          </template>
        </el-table-column>
        <el-table-column label="Uploaded By" prop="userName"></el-table-column>
        <el-table-column
          label="Action"
          fixed="right"
          v-if="p('Production.Firmware & Software.Upload')"
        >
          <template slot-scope="scope">
            <span
              class="underline blue-font pointer mr-10 move-btn"
              @click="moveToProd(scope.row.id)"
            >
              MOVE TO PRODUCTION
            </span>
            <span
              v-if="!scope.row.isStaging"
              class="underline blue-font pointer move-btn"
              @click="moveToStage(scope.row.id)"
            >
              MOVE TO STAGING
            </span>
          </template>
        </el-table-column>
      </el-table>
      <UploadNewProductionFw ref="uploadNewProductionFw" />
    </div>
  </div>
</template>

<script>
import UploadNewProductionFw from '@/components/production/pod/UploadNewProductionFw'
import moment from 'moment'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import { environments } from '../../../const'
export default {
  data() {
    return {
      environments,
      moment,
      loading: false,
      data: [],
      releaseHistory: []
    }
  },
  components: {
    UploadNewProductionFw
  },
  mounted() {
    this.getData()
  },
  methods: {
    uploadNew() {
      this.$refs.uploadNewProductionFw.openDialog()
    },
    getData() {
      this.loading = true
      ApiService.GetFirmwares()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data.filter(item => {
              return item.isProduction
            })
            this.releaseHistory = response.data.data.filter(item => {
              return !item.isProduction
            })
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    moveToProd(id) {
      ApiService.MoveToProd(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    moveToStage(id) {
      ApiService.MovetoStage(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
